import HttpClient from "shared/repositories/HttpClient";
import { GetFreeFortuneTagRes } from "shared/types";

export class FreeFortuneTagRepository {
  private getPath(id: number) {
    return id ? `/free_fortune/tags/${id}` : null;
  }

  public get(id: number) {
    const path = this.getPath(id);

    return {
      path,
      data: () =>
        HttpClient.miror
          .get<GetFreeFortuneTagRes>(path)
          .then((res) => res.data),
    };
  }
}
